// components/TableSkeleton.jsx
import React from "react";

const shimmer =
  "relative overflow-hidden before:absolute before:inset-0 before:-translate-x-full before:animate-[shimmer_1.2s_infinite] before:bg-gradient-to-r before:from-transparent before:via-white/40 before:to-transparent";

export default function TableSkeleton({ rows = 8 }) {
  return (
    <div className="bg-white rounded-lg px-6 py-4 pb-0 shadow-sm ring-1 ring-slate-100">
      <div className="overflow-x-auto">
        {/* Header */}
        <table className="w-full text-sm">
          <thead className="sticky top-0 bg-white z-10">
            <tr className="border-b  ">
              <th className="px-4 py-2 text-left min-w-[56px]">
                <div className={`h-3 w-6 rounded bg-slate-200 ${shimmer}`} />
              </th>
              <th className="px-4 py-2 text-center min-w-[110px]">
                <div
                  className={`mx-auto h-3 w-20 rounded bg-slate-200 ${shimmer}`}
                />
              </th>
              <th className="px-4 py-2 text-left min-w-[180px]">
                <div className={`h-3 w-40 rounded bg-slate-200 ${shimmer}`} />
              </th>
              <th className="px-4 py-2 text-left min-w-[120px]">
                <div className={`h-3 w-24 rounded bg-slate-200 ${shimmer}`} />
              </th>
              <th className="px-4 py-2 text-left min-w-[130px]">
                <div className={`h-3 w-28 rounded bg-slate-200 ${shimmer}`} />
              </th>
              <th className="px-4 py-2 text-left min-w-[140px]">
                <div className={`h-3 w-36 rounded bg-slate-200 ${shimmer}`} />
              </th>
              <th className="px-4 py-2 text-left min-w-[160px]">
                <div className={`h-3 w-40 rounded bg-slate-200 ${shimmer}`} />
              </th>
              <th className="px-4 py-2 text-left min-w-[140px]">
                <div
                  className={`h-3 w-28 rounded-full bg-slate-200 ${shimmer}`}
                />
              </th>
              <th className="px-4 py-2 min-w-[140px]">
                <div className={`h-3 w-16 rounded bg-slate-200 ${shimmer}`} />
              </th>
            </tr>
          </thead>

          <tbody>
            {Array.from({ length: rows }).map((_, i) => (
              <tr
                key={i}
                className="border-b motion-safe:animate-[rowIn_260ms_ease-out]"
                style={{ animationDelay: `${(i % 12) * 15}ms` }}
              >
                {/* STT */}
                <td className="px-4 py-3">
                  <div className={`h-3 w-6 rounded bg-slate-200 ${shimmer}`} />
                </td>
                {/* Mẫu (hình) */}
                <td className="px-4 py-3">
                  <div
                    className={`mx-auto h-20 w-20 rounded-md bg-slate-200 ${shimmer}`}
                  />
                </td>
                {/* Tên */}
                <td className="px-4 py-3">
                  <div className={`h-3 w-40 rounded bg-slate-200 ${shimmer}`} />
                </td>
                {/* Số đơn */}
                <td className="px-4 py-3">
                  <div className={`h-3 w-24 rounded bg-slate-200 ${shimmer}`} />
                </td>
                {/* Ngày nộp */}
                <td className="px-4 py-3">
                  <div className={`h-3 w-28 rounded bg-slate-200 ${shimmer}`} />
                </td>
                {/* Phân loại */}
                <td className="px-4 py-3">
                  <div className={`h-3 w-36 rounded bg-slate-200 ${shimmer}`} />
                </td>
                {/* Chủ đơn */}
                <td className="px-4 py-3">
                  <div className={`h-3 w-40 rounded bg-slate-200 ${shimmer}`} />
                </td>
                {/* Trạng thái (pill) */}
                <td className="px-4 py-3">
                  <div
                    className={`h-6 w-28 rounded-full bg-slate-200 ${shimmer}`}
                  />
                </td>
                {/* Action buttons */}
                <td className="px-4 py-3">
                  <div className="flex items-center gap-3 justify-start">
                    <div
                      className={`h-5 w-5 rounded bg-slate-200 ${shimmer}`}
                    />
                    <div
                      className={`h-5 w-5 rounded bg-slate-200 ${shimmer}`}
                    />
                    <div
                      className={`h-5 w-5 rounded bg-slate-200 ${shimmer}`}
                    />
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {/* Keyframes */}
        <style>{`
          @keyframes rowIn {
            from { opacity: 0; transform: translateY(4px); }
            to   { opacity: 1; transform: translateY(0); }
          }
          @keyframes shimmer {
            100% { transform: translateX(100%); }
          }
          @media (prefers-reduced-motion: reduce) {
            .animate-[rowIn_260ms_ease-out] { animation: none !important; }
            .before\\:animate-\\[shimmer_1\\.2s_infinite\\]::before { animation: none !important; }
          }
        `}</style>
      </div>
    </div>
  );
}
